//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import  Input from './Input';
export default {
  props: {
    //color: String,
  },
  components: {
  // 'Input': Input,
    },
  data () {
    return {
      phoneNumber: '',
      msgNumber: '',
      content: '获取验证码',
      totalTime: 60,
      canClick: true, //添加canClick
      msgError: 0,
      phoneError:0,
      flag: true,
      flag2: false,
      flag3: false
    }
  },
  watch: {
    'msgNumber': function () {
      this.msgError = false
      if(this.msgNumber.length === 6){
        this.flag2 = true
        console.log(this.flag2)
      }
    },
    'phoneNumber': function () {
      this.phoneError = false
    },
  },
  methods: {

  closeit(){
  this.$emit('closeLogin');
  },
  click(){
    let that = this;
    if(this.flag){
      this.flag = false
      this.getmsg()
      setTimeout(function(){
        that.flag = true;
      }, 60000);
    }
    },
  getmsg() {
    this.canClick = false
    let param = new URLSearchParams();
    param.append("phone", this.phoneNumber);
    if (typeof (this.phoneNumber) === 'undefined' || this.phoneNumber.length === 0) {
      this.phoneError = true
      this.canClick = true
      return false;
    } else if (this.phoneNumber.length != 8) {
      this.phoneError = true
      this.canClick = true
      return false;
    }
    //this.countDown();
    this.$http.getSms(`/ticket_racing/birthdaygift/sendCode`, param).then(res =>{
      if(res.data.body.status === 0){
        this.flag3 = true
        this.countDown();
      }else {
        this.phoneError = true
        this.canClick = true
        this.flag= true
      }
    });
    return null;
  },
  goLogin(){
    if (this.phoneNumber.length !== 8) {
      this.phoneError = true
      return false;
    }
    if ( this.msgNumber.length === 0) {
      this.msgError = true
      return false;
    }
    if (!(this.flag3&&this.flag2)) {
      return false;
    }
    let param = {};
      param = {
      phone: this.phoneNumber,
      code: this.msgNumber,
    }
    this.$http.get(`/ticket_racing/birthdaygift/verifyCode`, param).then(res =>{
      if(res.data.body.status === true){
        this.$emit('closeLogin',this.phoneNumber);
      }else{
        this.msgError = true
      }
    });
  },
  countDown () {
    this.content = this.totalTime + 's'
    let clock = window.setInterval(() => {
      this.totalTime--
      this.content = this.totalTime + 's'
      if (this.totalTime < 0) {
      window.clearInterval(clock)
      this.content = '重新发送验证码'
      this.totalTime = 60
      this.canClick = true  //这里重新开启
      }
    },1000)
  }
  }
}



// WEBPACK FOOTER //
// ./src/page/birthday/LoginWindow.vue